import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { Member } from '../../../../../types/entity.types';

import { formatUsername } from '../../../../../utils/util';

import ProfilePicture from '../../../../common/profile-picture/ProfilePicture';

import BadgesContainer from '../../../../../containers/badges/Badges.container';

import './tribe-members.scss';

type Props = {
  members: Member[];
};

const TribeMembers = ({ members }: Props) => {
  const [searchParams] = useSearchParams();

  const hasSubProgrammes = searchParams.get('hasSubProgrammes') === 'true';

  return (
    <div className="tribe-members" data-testid="tribe-members">
      <p className="tribe-members__header">Members</p>
      {members.map((member, index) => {
        if (index > 4 || !member.username) {
          return <React.Fragment key={index} />;
        }
        return (
          <div className="tribe-members__member" key={index}>
            <ProfilePicture src={member.profilePicture} alt={`${member.username} - profile`} small />
            <p className="tribe-members__member__name">{formatUsername(member.username)}</p>
            <div className="tribe-members__member__name__badge">
              <BadgesContainer
                memberReference={member.memberExternalReference}
                badgeReferences={member?.memberBadgeIconExternalReferences ?? []}
              />
            </div>
            {member.admin && <span className="tribe-members__member__admin-block">Admin</span>}
          </div>
        );
      })}
      <Link to={`member-engagement?hasSubProgrammes=${hasSubProgrammes}`}>View All members</Link>
    </div>
  );
};

export default TribeMembers;
